import { CUSTOMER_API_BASE_URL } from '../config/env';

export type FluxJobStatus = 'queued' | 'generating' | 'storing' | 'ready' | 'failed' | 'cancelled';
export interface FluxCandidate { candidateId: string; url: string; prompt: string; provider: 'replicate-flux' }
export interface FluxJob {
  jobId: string;
  status: FluxJobStatus;
  progress: number;
  prompt: string;
  candidates?: FluxCandidate[];
  error?: { code: string; message: string };
}

async function parse<T>(response: Response): Promise<T> {
  const payload = await response.json().catch(() => ({})) as T & { error?: string | { message?: string } };
  if (!response.ok) {
    const message = typeof payload.error === 'string' ? payload.error : payload.error?.message;
    throw new Error(message ?? `Image generation request failed (${response.status})`);
  }
  return payload;
}

export async function createFluxJob(sceneId: string, prompt: string, count = 3): Promise<FluxJob> {
  return parse(await fetch(`${CUSTOMER_API_BASE_URL}/api/flux/jobs`, {
    method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sceneId, prompt, count }),
  }));
}
export async function getFluxJob(jobId: string): Promise<FluxJob> {
  return parse(await fetch(`${CUSTOMER_API_BASE_URL}/api/flux/jobs/${encodeURIComponent(jobId)}`, { credentials: 'include' }));
}
export async function cancelFluxJob(jobId: string): Promise<void> {
  await fetch(`${CUSTOMER_API_BASE_URL}/api/flux/jobs/${encodeURIComponent(jobId)}`, { method: 'DELETE', credentials: 'include' });
}
